import { useEffect } from 'react';
import { useVoiceActivity } from 'hooks/useVoiceActivity';
import { VoiceActivityDetector } from './VoiceActivityDetector';

interface VoiceActivityAutoDetectorProps {
  hasPermission: boolean;
  hideIcon?: boolean;
}

/**
 * Самозапускающийся детектор голоса для экрана проверки устройств.
 * Изолирует 60fps setState от родительской страницы — ре-рендерится только это поддерево.
 */
export const VoiceActivityAutoDetector = ({
  hasPermission,
  hideIcon = false
}: VoiceActivityAutoDetectorProps) => {
  const { voiceVolume, startAnalysisWithNewStream, stopAnalysis } = useVoiceActivity();

  useEffect(() => {
    if (hasPermission) {
      startAnalysisWithNewStream();
    }
    return () => {
      stopAnalysis();
    };
  }, [hasPermission, startAnalysisWithNewStream, stopAnalysis]);

  return <VoiceActivityDetector volume={voiceVolume} isRecording hideIcon={hideIcon} />;
};
